import { gql } from '@apollo/client';

export const ADYEN_INIT_CARD_ADD = gql`
  mutation AdyenInitCardAdd($input: AdyenInitCardAddInput!) {
    adyenInitCardAdd(input: $input) {
      cardId
      transactionId
    }
  }
`;
